
import { useState } from 'react';
import { Prompt } from '../lib/types';
import { Button } from '@/components/ui/button';
import { ThumbsUp } from 'lucide-react';

interface PromptCardProps {
  prompt: Prompt;
  isVoted: boolean;
  onVote: (promptId: string) => void;
}

export const PromptCard: React.FC<PromptCardProps> = ({ prompt, isVoted, onVote }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  
  const handleVote = () => {
    if (!isVoted) {
      setIsAnimating(true);
      onVote(prompt.id);
      setTimeout(() => setIsAnimating(false), 500);
    }
  };
  
  return (
    <div className={`bg-bauhaus-offwhite border-2 border-bauhaus-green rounded-xl shadow-lg p-5 hover:shadow-xl transition-all duration-300 ${
      isVoted ? 'ring-2 ring-bauhaus-brown ring-opacity-70' : ''
    } ${
      isAnimating ? 'scale-105' : ''
    }`}>
      <div className="flex justify-between items-start gap-3 mb-3">
        <h3 className="text-xl font-['Bebas_Neue'] tracking-wider text-bauhaus-darkgreen uppercase">{prompt.text}</h3>
        <Button
          size="sm"
          className={`${isVoted 
            ? 'bg-bauhaus-brown text-bauhaus-offwhite hover:bg-bauhaus-brown/90' 
            : 'bg-transparent border-2 border-bauhaus-brown text-bauhaus-brown hover:bg-bauhaus-brown/10'
          } rounded-md px-3 shadow-md flex-shrink-0`}
          onClick={handleVote}
          disabled={isVoted}
        >
          <ThumbsUp className={`h-4 w-4 mr-1.5 ${isVoted ? 'fill-bauhaus-offwhite' : ''}`} />
          <span className="font-bold">{prompt.votes}</span>
        </Button>
      </div>
      <p className="text-sm text-bauhaus-darkgreen/80">
        What would you photograph for this prompt?
      </p>
    </div>
  );
};
